<div class="box--one">
  <i class="bi bi-plus-lg" *ngIf="iconType === 'plus'"></i>
  <i class="bi bi-heart-fill" *ngIf="iconType === 'heart'"></i>
</div>
